import { u, styled } from '../../../shared/theming-sc'

const StatusBar = styled.div`
    float: left;
    width: 100%;
    box-sizing: border-box;
    padding: ${u.getSpacing('small')}px 40px ${u.getSpacing('small')}px ${u.getSpacing('large')}px;
    background: ${u.getColor('greyDark')};
    margin-bottom: ${u.getSpacing('small')}px;
    position: relative;

     ${u.media.greaterThan('lg')`
     padding: ${u.getSpacing('small')}px 120px ${u.getSpacing('small')}px ${u.getSpacing('large')}px;
    `};
`

const StatusWrapper = styled.div`
    float: left;
    width: 50%;

     ${u.media.greaterThan('lg')`
      width: 80%;
    `};
`

const StatusItem = styled.p`
    color: white;
    font-size: ${u.getFontSize('md')};
    display: inline-block;
    margin-right: ${u.getSpacing('small')}px;
    line-height: 1.2;
    position: relative;
    padding-right: ${u.getSpacing('medium')}px;

    &.first-item {
          &:after {
            content: '';
            position: absolute;
            right: -12px;
            top: 0px;
            height: 18px;
            width: 1px;
            background: white;
            z-index: 10000;
            display: block;
          }
      }

    ${u.media.greaterThan('lg')`
      &.first-item {
          &:after {
            content: '';
            position: absolute;
            right: -12px;
            top: 0;
            height: 18px;
            width: 1px;
            background: white;
            z-index: 10000;
            display: block;
          }
      }
    `};

`

const StatusItemValue = styled.span`
    font-weight: bold;
`

const StatusItemClear = styled.span`
    display: block;
    position: absolute;
    right: 0;
    top: 0px;
    width: ${u.getSpacing('small')}px;
    height: ${u.getSpacing('small')}px;
    cursor: pointer;

    ${u.media.greaterThan('sm')`
      top: -2px;
    `};

    svg {
        position: absolute;
        left: 2px;
        top: 2px;
    }
`

const StatusClearAll = styled.a`
    display: block;
    position: relative;
    float: right;
    font-size: ${u.getFontSize('md')};
    text-decoration: underline;
    color: white;
    font-weight: bold;

    &:hover{
      color: white !important;
      cursor: pointer;
          }

    ${u.media.greaterThan('sm')`
      right: ${u.getSpacing('large')}px;
      top: ${u.getSpacing('small')}px;
      position: absolute;
    `};
`

export {
  StatusBar,
  StatusWrapper,
  StatusItem,
  StatusItemValue,
  StatusItemClear,
  StatusClearAll
}
